import React from "react";
import DeleteAccount from "../../components/DeleteAccount/index";

export default function index (){
    return (
        <>
        <DeleteAccount />
        
        
        </>
    ) 
};
